
<section
  id="safety"
  class="l-safety"
>
  <div class="o-container">
    <div class="o-grid -xs-middle -xs-full -xs-between">
      <div class="o-grid__item l-safety__grid -xs-24 -md-12">
        <div class="l-safety__content">
          <h2 class="title l-safety__content-title">
            segurança, do grego <span class="t-md-block">securité</span>
          </h2>

          <p class="l-safety__content-description">
            você compra usando cartão de crédito ou boleto bancário.
            <span class="t-xs-block">todos os dados são criptografados.</span>
          </p>

          <p class="l-safety__content-description">
            a gente só transfere o dinheiro ao vendedor depois que você,
            comprador, receber o produto nos conformes.
          </p>

          <p class="l-safety__content-description">
            caso você não goste, pode devolver.
          </p>
        </div>
      </div>

      <div class="o-grid__item -xs-24 -md-12">
        <div class="l-safety__wrapper">
          <figure class="l-safety__figure l-figure">
            <picture>
              <img
                class="l-image l-safety__image"
                :src="
                  require('@@/assets/images/landing-pages/how-to-buy/safety/safe_app.png')
                "
                :srcset="`
                  ${require('@@/assets/images/landing-pages/how-to-buy/safety/safe_app.png')},
                  ${require('@@/assets/images/landing-pages/how-to-buy/safety/safe_app@2x.png')} 2x
                `"
                alt="Imagem ilustrativa de um aparelho celular exibindo a página inicial do enjuapp."
              >
            </picture>
          </figure>
        </div>
      </div>
    </div>

    <div class="o-separator -line -gray t-xs-hide t-md-block">
      <hr>
    </div>
  </div>
</section>
